import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/relojchecador/justificacion-reloj-checador/';
export const optimizedURI = '/relojchecador/justificacion-reloj-checador-vista-optimized/';

/**
 * GET Justificacion Reloj
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getJustificacionesReloj = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};
/**
 * GET Justificacion Reloj
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getJustificacionesOptimizedReloj = async (params) => {
  try {
    const response = await API.get(optimizedURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};
/**
 * GET Justificacion Reloj
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getJustificacionReloj = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Justificacion Reloj
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postJustificacionReloj = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Justificacion Reloj
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchJustificacionReloj = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Justificacion Reloj
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteJustificacionReloj = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Justificacion Reloj
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarJustificacionReloj = async (id) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * RECHAZAR Justificacion Reloj
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const rechazarJustificacionReloj = async (id) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
